<template>
    <p>
        {{ $t('guide.guide_popover_step_2_desc') }}
    </p>
    <pt-button
        color="lightblue"
        :type="props.step.done ? 'outline' : 'contain'"
        @click="openDialog"
    >
        {{
            noActivation
                ? $t('guide.guide_popover_step_2_btn_install')
                : $t('guide.guide_popover_step_2_btn_install_check')
        }}
    </pt-button>
    <div :class="$style.link" v-if="noActivation">
        <pt-link @click="showVerifyDialog">
            {{ $t('guide.guide_popover_step_2_btn_check') }}
        </pt-link>
    </div>
</template>

<script lang="ts" setup>
import useEventBus from '@assets/plugins/eventBus';
import { computed } from 'vue';
import { useProfileInfo } from '@models/profile/useCurrentProfile';
import { GuideStep } from '@master/store/guide.store';

interface Props {
    step: GuideStep;
}

const props = defineProps<Props>();

const { profileInfo } = useProfileInfo();
const emit = defineEmits(['hide', 'next', 'update', 'trackEvent']);
const { eventBus } = useEventBus();

const noActivation = computed(() => {
    return profileInfo.value?.isActived !== 1;
});

function openDialog() {
    emit('hide');
    emit(
        'trackEvent',
        noActivation.value ? 'guide_install_click' : 'guide_install_view_code_click'
    );
    eventBus.$emit('hideVerifyDialog');
    eventBus.$emit('showSetup');
}

function showVerifyDialog() {
    emit('hide');
    emit('trackEvent', 'guide_install_check_click');
    eventBus.$emit('showVerifyDialog');
}
</script>

<style lang="scss" module>
@import '@style/import.scss';
.success_tips {
    width: 316px;
    height: 28px;
    border: 1px solid $pt-green-10;
    background-color: $pt-success-hover;
    border-radius: 3px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    font-size: 12px;
    margin-bottom: 12px;
    :global {
        .pt-icon {
            width: 20px;
            height: 20px;
            margin: 0 6px 0 8px;
        }
    }
}
.verify_after_install {
    display: block;
    text-decoration: underline;
    color: $pt-black-600;
    font-size: 12px;
    font-weight: 500;
    margin-top: 12px;
}
.link {
    :global {
        .pt-link--size-default {
            font-size: 12px;
            font-weight: 500;
            text-decoration: underline;
        }
    }
}
</style>
